import React, { Component } from 'react';

export class about extends Component {
  render () {
    return (
      <div id='about'>
        <div className='row'>
          <div className='col-xs-12 col-md-xu6'>
            <h2>Mission</h2>
            <p>
              {this.props.data
                ? this.props.data.paragraph
                : 'loading...'}
            </p>
            <div className='about-text'>
              <div className='row'>
                <div className='list-style'>
                  <div className='col-lg-6 col-sm-12 col-xs-12'>
                    <h3>Why Choose NewsLab?</h3>
                    <ul>
                      {this.props.data
                        ? this.props.data.Why.map(d => (
                          <li key={d + 'about-key'}>{d}</li>
                        ))
                        : 'loading'}
                    </ul>
                    <h3>
                      <a
                        href='https://rapidapi.com/stegopodai-stegopodai-default/api/news-summarizer'
                        target='_blank'
                      >
                                                Try out the News Summarizer as
                                                an API
                      </a>
                    </h3>
                  </div>
                </div>
                <div className='col-lg-6 col-sm-12 col-xs-12'>
                  <h3>Sample Generated Podcast</h3>
                  <iframe src="https://open.spotify.com/embed-podcast/show/6sACxxL20XxM2TjPYS0Ugv" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default about;
